var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TagInput',{staticClass:"filter-tag-input",attrs:{"placeholder":"filter by tag","selected-tags":_vm.selectedTags,"all-tags-names":_vm.allTagsNames,"allow-new":false,"autofocus":""},on:{"input":_vm.setTags,"clearAllTags":_vm.clearAll}})}
var staticRenderFns = []

export { render, staticRenderFns }